<template>
    <div>
        <div
            :style="takersColors"
            class="takers-style"
        >
            {{taker.name}}
        </div>
    </div>
</template>

<script>
export default {

    name: 'channel-overview-takers',

    props:{
        taker:{
            type: Object,
            required: true,
        },
        channelIsOn:{
            type: Boolean,
            required: true,
        },
    },

    data() {
        return {    
        };
    },
    computed:{
        takersColors(){
            if (this.channelIsOn === true) {
                if (this.taker.configuration === 'OFF'){
                    return `color: #409EFF;`;
                } else if (this.taker.blanking === true) {
                    return `color: #FFFFFF;`;
                } else if(this.taker.connected === true){
                    return `color: #31BD9B;`;
                } else if(this.taker.connected === false){
                    return `color: #FFDC42;`;
                }
            } else if(this.channelIsOn === false){
                if(this.taker.configuration === 'OFF'){
                    return `color: #409EFF`;
                }
                return `color: #FFDC42`;

            }
        },
    }
};
</script>

<style lang="css" scoped>
.takers-style{
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    font-size: 16px;
    line-height: 20px;
    font-weight: 500;
    text-transform: uppercase;
}
</style>




// WEBPACK FOOTER //
// src/components/page/ChannelsOverview/channel-overview-takers.vue